export default "__VITE_ASSET__e9ff3bee__"